import { render, staticRenderFns } from "./ModifyDnsViewModal.vue?vue&type=template&id=015ee3da&"
import script from "./ModifyDnsViewModal.vue?vue&type=script&lang=js&"
export * from "./ModifyDnsViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports